export default __webpack_public_path__ + "static/media/08_Watch-the-sky-change.10c90247.jpg";